import { makeStyles } from "@material-ui/core/styles";

import defaultTheme from "./index";
import defaultMuiTheme from "./default";




export const AppStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
      },
     
      content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        background:' rgb(245,246,248) !important',
      },
      flex:{
        display:'flex',
        alignItems:'center',
        minHeight:'inherit',
      },
      large: {
        width: 85,
        height: 55,
        marginLeft:8,
      },
      flexgrow:{
        fontWeight:400,
        fontSize:32,
        paddingLeft:16,
    
      },
      container: {
        marginTop: defaultMuiTheme.appBarHeight,
        marginRight: "25px",
        marginBottom:"20px",
        marginLeft:"25px",
        [defaultTheme.default.breakpoints.down("md")]: {
         
        marginTop: defaultMuiTheme.appBarHeight,
        marginRight: "8px",
        marginBottom:"20px",
        marginLeft:"8px",
        },
        paddingLeft: defaultTheme.default.drawer.width,
        [defaultTheme.default.breakpoints.down("sm")]: {
          paddingLeft: 0,
        },    
      },
      containerFull: {
        paddingLeft: defaultTheme.default.drawer.miniWidth,
        [defaultTheme.default.breakpoints.down("sm")]: {
          paddingLeft: 0,
        },
      },
      settingBtn: {
        top: 80,
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        color: "white",
        width: 48,
        right: 0,
        height: 48,
        opacity: 0.9,
        padding: 0,
        zIndex: 999,
        position: "fixed",
        minWidth: 48,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
}));